import { render, staticRenderFns } from "./DevelopmentTools.vue?vue&type=template&id=6158e16a&"
import script from "./DevelopmentTools.vue?vue&type=script&lang=js&"
export * from "./DevelopmentTools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports